import React from 'react';
import { Preloader } from '@beef/legacy-ui-kit';
import classNames from 'classnames/bind';
import styles from "../../styles.pcss";
var cx = classNames.bind(styles);
export var RenderLoader = function RenderLoader() {
  return /*#__PURE__*/React.createElement("div", {
    className: cx('preloadWrapper'),
    "data-t-id": "components-RenderLoader"
  }, /*#__PURE__*/React.createElement(Preloader, {
    size: "100"
  }));
};